// removed by extract-text-webpack-plugin
module.exports = {"contact-form":"src-components----ContactForm-module---contact-form---2PmYE","success-message":"src-components----ContactForm-module---success-message---3Lum-","text-container":"src-components----ContactForm-module---text-container---2iLZG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactForm.module.scss
// module id = 201
// module chunks = 70144966829960 247968605717249